import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { WebPortal } from '@gk/gk-modules';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { MainRoutes } from '../../guards/guard.models';
import { WebPortalService } from '../../services/web-portal/web-portal.service';

@Injectable({ providedIn: 'root' })
export class WebPortalResolver implements Resolve<WebPortal> {
  static field = 'webPortal';

  constructor(private webPortalService: WebPortalService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<WebPortal> {
    const path = _.get(route.url, '[0].path', '') as MainRoutes;
    return this.webPortalService.getWebPortalDataByCurrentRoute(path);
  }
}
